import React from 'react';
import { Section } from '../components/Section';
import { StartHere } from '../components/StartHere';
import { asset } from '../data/redesignAssets';
import { TEAM } from '../data/team';
export function About() {
  return <>
      <Section n="01" label="About" noTop contentClassName="page-hero" data-id="element-317" data-mp="29l6pp8bd7jge">
        <h1 className="h1" style={{
        maxWidth: 760
      }} data-id="element-318" data-mp="2ehx65wr30h2c">
          We build the part of AI
          <br className="d" data-id="element-319" data-mp="327rhuaznzzl0" /> nobody was governing.
        </h1>
        <p className="lede" style={{
        maxWidth: 800
      }} data-id="element-320" data-mp="32682qnpqvukt">
          Every enterprise AI stack has a shelf for knowledge: <em data-id="element-321" data-mp="3751bk2u36xen">graphs, semantic search, vector stores</em>.{' '}
          <strong data-id="element-322" data-mp="2s9lf5r61apf3">None of them has a shelf for the obligations that must be in the prompt before the model generates a single token.</strong>{' '}
          So whether the must-have rules make it into the prompt depends on who’s typing. Synthia exists to close that gap: to make the
          instructions complete, to get them in before the model’s attention is spent, and to end the rework tax that starts the moment
          your AI gets instructions that are missing context.
        </p>
      </Section>

      <section className="bleed sec-dk does" data-id="element-323" data-mp="1pkjkgw0cmd7g">
        <div className="sec" style={{
        borderTop: 0
      }} data-id="element-324" data-mp="23i83dyauva9v">
          <div className="sec-m" data-id="element-325" data-mp="23jrny13jo7hg">
            <div className="sec-l" data-id="element-326" data-mp="1yjn5i5j2t2ol">Why</div>
          </div>
          <div className="why-c" data-id="element-327" data-mp="1yi290ad7b9o3">
            <p className="why" data-id="element-328" data-mp="2dgnva3hpinkf">
              The fifth time we saw the same correction, we stopped calling it a correction. It was a missing obligation, and the model
              kept committing us without it.
              <br data-id="element-329" data-mp="2m9hgsinqyj6q" />
              <span style={{
              color: 'var(--mint)'
            }} data-id="element-330" data-mp="2m7wn0v99b49x">So we automated the obligations.</span>
            </p>
          </div>
        </div>
      </section>

      <Section n="03" label="The people" data-id="element-331" data-mp="2i9qkjzfgbaut">
        <h2 className="h2" data-id="element-332" data-mp="2w8708fvakbp3">Humans in the loop.</h2>
        <div className="team" data-id="element-333" data-mp="2w4svx232hsf0">
          {TEAM.map(p => <div className="person" key={p.name} data-id="element-334" data-mp="2r9diuccvw0jn">
              <img src={asset(p.photo)} alt={p.name} loading="lazy" data-id="element-335" data-mp="1oumo5qatxek0" />
              <div className="id" data-id="element-336" data-mp="1owha97xu7cpo">
                <div className="nm" data-id="element-337" data-mp="1svyi280qkly0">{p.name}</div>
                <div className="rl" data-id="element-338" data-mp="1swrfujhpw140">{p.role}</div>
              </div>
              <div className="bio" data-id="element-339" data-mp="1xv2pou80ibm8">{p.bio}</div>
            </div>)}
        </div>
      </Section>

      <StartHere n="04" data-id="element-340" data-mp="22n2xf8ubq8td" />
    </>;
}